import { PanelRow } from "@wordpress/components";
import { ToggleControl } from "@wordpress/components";
import { SelectControl } from "@wordpress/components";
import { Button } from "@wordpress/components";
import { PanelBody } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import BMediaUpload from "../../../../../components/BMediaUpload/BMediaUpload";
import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

const ModelForm = ({ attributes, setAttributes }) => {
  const { model, models, multiple, isPremium } = attributes;

  const updateModels = (key, value, index) => {
    const newModels = [...models];
    newModels[index][key] = value;
    setAttributes({ models: newModels });
  };

  const modelViewer = ["gltf", "glb"].includes(model.ext || "glb");

  return (
    <PanelBody title={__("Model", "b3d-viewer-lite")}>
      {modelViewer && (
        <PanelRow>
          {/* <label></label> */}
          <BControlPro label={__("Use Multiple Model?", "b3d-viewer-lite")} isPremium={isPremium} Component={ToggleControl} checked={multiple} onChange={() => setAttributes({ multiple: !multiple })} />
        </PanelRow>
      )}

      {multiple && isPremium ? (
        <>
          {models?.map((model, index) => (
            <PanelBody key={index} title={__("Model ", "b3d-viewer-lite") + parseInt(index + 1)} initialOpen={false} className="modelPanel">
              <BMediaUpload value={model?.modelUrl} placeholder={__("Model URL", "b3d-viewer-lite")} onSelect={(modelUrl) => updateModels("modelUrl", modelUrl, index)} type={["model/gltf-binary"]} label={__("Model URL", "b3d-viewer-lite")} />
              <BMediaUpload value={model?.poster} placeholder={__("Model Poster", "b3d-viewer-lite")} onSelect={(poster) => updateModels("poster", poster, index)} type={["image"]} label={__("Model Poster", "b3d-viewer-lite")} />
              <PanelRow>
                <label>{__("Use Decoder", "b3d-viewer-lite")}</label>
                <SelectControl
                  options={[
                    { label: "None", value: "none" },
                    { label: "Draco", value: "draco" },
                  ]}
                  value={model?.decoder}
                  onChange={(decoder) => updateModels("decoder", decoder, index)}
                />
              </PanelRow>
              {model?.decoder === "draco" && (
                <>
                  <BMediaUpload value={model?.binFile} placeholder={__("Bin File", "b3d-viewer-lite")} onSelect={(binFile) => updateModels("binFile", binFile, index)} type={["application/octet-stream"]} label={__("Bin File", "b3d-viewer-lite")} />
                </>
              )}
              {models.length !== 1 && (
                <PanelRow className="modelRemover">
                  <Button
                    variant="primary"
                    onClick={() => {
                      const newModels = [...models];
                      newModels.splice(index, 1);
                      setAttributes({ models: newModels });
                    }}
                  >
                    {__("Remove", "b3d-viewer-lite")}
                  </Button>
                </PanelRow>
              )}
            </PanelBody>
          ))}

          <PanelRow>
            <Button
              variant="primary"
              onClick={() => {
                const newModels = [...models];
                newModels.push({});
                setAttributes({ models: newModels });
              }}
            >
              {__("Add New", "b3d-viewer-lite")}
            </Button>
          </PanelRow>
        </>
      ) : (
        <>
          <BMediaUpload
            value={model?.modelUrl}
            placeholder={__("Model URL", "b3d-viewer-lite")}
            onSelect={(modelUrl) => {
              setAttributes({ model: { ...model, modelUrl, ext: modelUrl.split(".")?.[modelUrl.split(".").length - 1] } });
            }}
            type={["model/gltf-binary", "model/obj", "application/octet-stream", "application/x-3ds", "application/vnd.ms-pki.stl", "text/vnd.in3d.3dml", "application/collada+xml", "model/vrml", "application/vnd.ms-3mfdocument"]}
            label={__("Model URL", "b3d-viewer-lite")}
          />
          {modelViewer && (
            <>
              <BMediaUpload value={model?.poster} placeholder={__("Model Poster", "b3d-viewer-lite")} onSelect={(poster) => setAttributes({ model: { ...model, poster } })} type={["image"]} label={__("Model Poster", "b3d-viewer-lite")} />
              <PanelRow>
                <label>{__("Use Decoder", "b3d-viewer-lite")}</label>
                <SelectControl
                  options={[
                    { label: "None", value: "none" },
                    { label: "Draco", value: "Draco" },
                  ]}
                  vlaue={model?.decoder}
                  onChange={(decoder) => setAttributes({ model: { ...model, decoder } })}
                />
              </PanelRow>
              {model?.decoder === "Draco" && (
                <>
                  <BMediaUpload value={model?.binFile} placeholder={__("Bin File", "b3d-viewer-lite")} onSelect={(binFile) => setAttributes({ model: { ...model, binFile } })} type={["application/octet-stream"]} label={__("Bin File", "b3d-viewer-lite")} />
                </>
              )}
            </>
          )}
        </>
      )}
    </PanelBody>
  );
};

export default ModelForm;

// {models.length !== 1 && (
//   <IconButton
//     variant="secondary"
//     className="btn-dismiss"
//     icon="dismiss"
//     onClick={() => {
//       const newModels = [...models];
//       newModels.splice(index, 1);
//       setAttributes({ models: newModels });
//     }}
//   />
// )}
